module.exports = __webpack_public_path__ + "img/logo-720x240.95a3e64b.png";